import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useNavigate } from 'react-router-dom'
import { Funcionario, funcionario as api } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

interface IProps {
    open: boolean
    onClose: () => void
    funcionario: Funcionario
}

export function ExcluirFuncionario({ onClose, open, funcionario }: IProps) {
    const navigate = useNavigate()
    const empresaId = useStore(state => state.companyId)
    const setFuncionarioId = useStore(state => state.setEmployeeId)

    const { mutateAsync, isLoading } = api.mutations.useSoftDelete({
        queryParams: {
            empresaId,
        },
        invalidateQuery: true,
    })

    function handleSubmit() {
        return mutateAsync(funcionario, {
            onSuccess: () => {
                toast.success('Funcionario removido com sucesso!')
                setFuncionarioId(-1)
                navigate('/cadastros/funcionarios')
            },

            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Funcionários']}
            open={open}
            onClose={onClose}
            loading={isLoading}
            onConfirm={handleSubmit}
            fecharAoConfirmar={false}
            title={
                <>Você tem certeza que deseja excluir {funcionario?.nome}?</>
            }
        />
    )
}
